



















import {Vue, Component} from 'vue-property-decorator'
import axios, { AxiosError } from 'axios'
import { errorHandler, getUrl } from '@/api/utils/http-helpers'
import NavButton from '@/components/shared/NavButton'
import { Pages } from '@/pages'

@Component({
  components: {
    NavButton: NavButton
  }
})
export default class DocumentViewer extends Vue {
  private homeRouteLink: any = Pages.HOME.routeLink
  private pdfSrc: any = null

  async created() {
    await this.loadPDF()
  }

  beforeDestroy() {
    // cleanup
    if (this.pdfSrc) {
      URL.revokeObjectURL(this.pdfSrc)
    }
  }

  async loadPDF() {
    const url = getUrl('/documents')
    await axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        this.pdfSrc = URL.createObjectURL(blob)
      })
      .catch((e: AxiosError) => {
        errorHandler(e.toString ())
      })
  }
}
